import { render, staticRenderFns } from "./TooltipExt.vue?vue&type=template&id=57dfe7a2&scoped=true"
import script from "./TooltipExt.vue?vue&type=script&lang=js"
export * from "./TooltipExt.vue?vue&type=script&lang=js"
import style0 from "./TooltipExt.vue?vue&type=style&index=0&id=57dfe7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfe7a2",
  null
  
)

export default component.exports